import styled from 'styled-components';
import { Flex } from 'UI';
import { Menu } from 'UI/Menu/Menu';

export const SListViewWrapper = styled(Flex)`
  width: 100%;
`;

export const SL1SideMenu = styled(Menu)`
  background-color: ${({ theme }) => theme.color.grey95} !important;
  max-width: 300px;
  border-inline-end: none !important;

  .ant5-menu-item {
    height: auto !important;
    line-height: 1.3 !important;
    padding: 8px;
    white-space: normal !important;
    border-radius: 0;
    margin: 0;
    width: 100%;
    color: ${({ theme }) => theme.color.grey35};

    &:hover {
      background-color: ${({ theme }) => theme.color.grey85} !important;
      color: ${({ theme }) => theme.color.brand_black} !important;
    }

    span {
      white-space: normal !important;
    }
  }

  .ant5-menu-item-selected {
    background-color: ${({ theme }) => theme.color.grey85} !important;
    border-radius: 4px;
  }
`;

export const SL2GroupHeader = styled(Flex)`
  min-height: 40px;
  background: ${({ theme }) => theme.color.grey95};
`;

export const SL3ItemsGrid = styled.div`
  margin: 0;
  padding: 0;
  list-style: disc;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const SL3Item = styled(Flex)`
  border-bottom: 1px solid ${({ theme }) => theme.color.grey85};
  min-height: 30px;
  padding-left: 15px;
  margin-bottom: 6px;
`;
